import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import NewsCard from "@/components/feature/NewsCard";
import { newsList, topics } from "@/mocks/news";
import { categories, sortedByHeat, sortedByTime } from "@/utils/news";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import HomeSidebar from "./components/HomeSidebar";
import TopicPicks from "./components/TopicPicks";

const TABS = [
  { key: "all", label: "全部爆料" },
  { key: "society", label: "社会爆料" },
  { key: "entertainment", label: "娱乐爆料" },
];

export default function Home() {
  useDocumentMeta({
    title: "爆料网-最新社会娱乐爆料资讯平台",
    description:
      "爆料网致力于提供最新的社会新闻和娱乐八卦爆料，覆盖热点事件和明星动态，助您快速获取第一手资讯。",
    keywords: "爆料网,最新爆料,社会新闻,娱乐八卦,热点资讯,明星动态,第一手爆料",
  });

  const [tab, setTab] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setLoading(false), 420);
    return () => window.clearTimeout(timer);
  }, []);

  const latest = useMemo(() => sortedByTime(newsList), []);
  const hot = useMemo(() => sortedByHeat(newsList), []);
  const filtered = useMemo(
    () => (tab === "all" ? latest : latest.filter((item) => item.categorySlug === tab)),
    [tab, latest],
  );

  return (
    <PageLayout>
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 pt-4 md:pt-6">
        <HeroCarousel slides={hot.slice(0, 4)} />

        <section className="mt-4 md:mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 px-4 py-4 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span
                className={`w-12 h-12 shrink-0 rounded-lg flex items-center justify-center text-2xl ${
                  index === 0
                    ? "bg-primary-100 text-primary-600"
                    : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={index === 0 ? "ri-government-line" : "ri-movie-2-line"} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </span>
                  <span className="font-label text-[11px] tracking-[0.2em] text-foreground-400">
                    {cat.en}
                  </span>
                </span>
                <span className="mt-1 block text-xs leading-5 text-foreground-500 line-clamp-2-safe">
                  {cat.desc}
                </span>
              </span>
              <span className="hidden sm:flex flex-col items-end shrink-0">
                <span className="font-label text-2xl text-foreground-900 leading-none">
                  {newsList.filter((n) => n.categorySlug === cat.slug).length}
                </span>
                <span className="mt-1 text-[11px] text-foreground-400">条在库</span>
              </span>
            </Link>
          ))}
        </section>

        <div className="mt-8 md:mt-10 flex flex-col lg:flex-row gap-6 lg:gap-7 items-start">
          <section className="w-full lg:flex-1 min-w-0">
            <div className="flex flex-wrap items-end justify-between gap-3 pb-3 border-b border-background-200">
              <div>
                <div className="flex items-center gap-2">
                  <span className="w-1.5 h-5 rounded-full bg-primary-500" />
                  <h2 className="text-xl md:text-[22px] font-black text-foreground-950">最新爆料</h2>
                </div>
                <p className="mt-2 text-sm text-foreground-500">
                  按发布时间倒序排列 · 共 {latest.length} 条
                </p>
              </div>
              <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200">
                {TABS.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() => setTab(item.key)}
                    className={`px-3 py-1.5 rounded-full text-[13px] transition-colors cursor-pointer whitespace-nowrap ${
                      tab === item.key
                        ? "bg-background-50 text-primary-600 font-bold"
                        : "text-foreground-600 hover:text-primary-600"
                    }`}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>

            {loading ? (
              <ul className="mt-4 space-y-3">
                {[0, 1, 2, 3, 4].map((i) => (
                  <li
                    key={i}
                    className="flex gap-4 p-4 rounded-lg border border-background-200/70 bg-background-50"
                  >
                    <div className="w-[224px] h-[138px] rounded-md bg-background-200 animate-pulse shrink-0 hidden sm:block" />
                    <div className="flex-1 min-w-0 space-y-3 py-1">
                      <div className="h-3 w-24 rounded bg-background-200 animate-pulse" />
                      <div className="h-4 w-3/4 rounded bg-background-200 animate-pulse" />
                      <div className="h-3 w-full rounded bg-background-200 animate-pulse" />
                      <div className="h-3 w-2/3 rounded bg-background-200 animate-pulse" />
                    </div>
                  </li>
                ))}
              </ul>
            ) : filtered.length === 0 ? (
              <div className="mt-4 rounded-lg border border-dashed border-background-300 bg-background-100/60 py-14 text-center">
                <i className="ri-inbox-line text-3xl text-foreground-400" />
                <p className="mt-3 text-sm text-foreground-600">暂无最新爆料，敬请期待</p>
              </div>
            ) : (
              <ul className="mt-4 space-y-3">
                {filtered.slice(0, 8).map((item) => (
                  <li key={item.id}>
                    <NewsCard item={item} />
                  </li>
                ))}
              </ul>
            )}

            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/society"
                className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看更多社会爆料
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/category/entertainment"
                className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-md border border-background-300 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看更多娱乐爆料
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </section>

          <HomeSidebar topics={topics} hotList={hot.slice(0, 6)} />
        </div>

        <TopicPicks />

        <section className="mt-12 rounded-lg overflow-hidden border border-background-200/80 bg-background-100">
          <div className="grid grid-cols-1 md:grid-cols-4">
            {[
              { value: `${newsList.length}`, label: "在库爆料", icon: "ri-file-list-3-line" },
              { value: `${topics.length}`, label: "进行中专题", icon: "ri-folder-open-line" },
              { value: "24h", label: "持续更新", icon: "ri-time-line" },
              { value: "100%", label: "公开信息整理", icon: "ri-verified-badge-line" },
            ].map((stat, index) => (
              <div
                key={stat.label}
                className={`flex items-center gap-3 px-5 py-6 ${
                  index < 3 ? "md:border-r border-b md:border-b-0 border-background-300/60" : ""
                }`}
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50 text-primary-500 text-xl">
                  <i className={stat.icon} />
                </span>
                <div>
                  <p className="font-label text-2xl leading-none text-foreground-950">{stat.value}</p>
                  <p className="mt-1.5 text-xs text-foreground-500">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 md:mt-10 rounded-lg overflow-hidden border border-primary-200 bg-primary-50 px-5 md:px-8 py-7 md:py-9">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-5">
            <div>
              <p className="font-label text-xs tracking-[0.24em] text-primary-600">TIP LINE</p>
              <h2 className="mt-2 text-xl md:text-2xl font-black text-foreground-950">
                看见什么，就告诉我们什么
              </h2>
              <p className="mt-2 text-sm leading-7 text-foreground-600 max-w-[620px]">
                每一条爆料都会经过来源核对。你可以选择匿名提交，我们只在确认信息后才会公开发布。
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap shrink-0 cursor-pointer"
            >
              <i className="ri-send-plane-line" />
              前往线索提交页
            </Link>
          </div>
        </section>
      </div>
    </PageLayout>
  );
}